"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  TciButton = _require.TciButton,
  ButtonPopup = _require.ButtonPopup;
const formatButton = (properties, options = {}) => {
  // console.log('formatButton-', properties);
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$colType = properties.colType,
    colType = _properties$colType === void 0 ? '' : _properties$colType,
    _properties$sizeType = properties.sizeType,
    sizeType = _properties$sizeType === void 0 ? '' : _properties$sizeType,
    _properties$alignType = properties.alignType,
    alignType = _properties$alignType === void 0 ? '' : _properties$alignType,
    _properties$txt = properties.txt,
    txt = _properties$txt === void 0 ? '' : _properties$txt,
    _properties$case = properties.case1,
    case1 = _properties$case === void 0 ? {} : _properties$case,
    _properties$colorThem = properties.colorTheme,
    colorTheme = _properties$colorThem === void 0 ? '' : _properties$colorThem;
  const configuration = {};
  configuration.colType = colType || '';
  configuration.sizeType = sizeType || '';
  configuration.alignType = alignType || '';
  configuration.txt = txt || '';
  configuration.colorTheme = colorTheme;
  if (case1) {
    if (case1.clickType1 === 'openUrl' && case1.btnLink) {
      const href = formatUrlString(case1.btnLink);
      configuration.clickType1 = 'openUrl';
      configuration.extendProps = {
        'report-event-goal': 'click_button',
        'report-event': 'click_a_button',
        'report-ext1': txt,
        'report-ext2': href
      };
      configuration.callback = function () {
        window.open(href);
      };
    } else if (case1.clickType1 === 'btn') {
      configuration.clickType1 = 'btn';
      configuration.extendProps = {
        'report-event-goal': 'click_button',
        'report-event': 'click_popup_button',
        'report-ext1': txt
      };
      configuration.configuration = {};
      configuration.configuration.modalTitle = case1.popTitle || '';
      configuration.configuration.richTextContent = case1.textarea || '';
      configuration.configuration.list = [];
      if (case1.boxes2) {
        const btnLeft = {};
        btnLeft.type = 'cancel';
        switch (case1.case3 && case1.case3.clickType3) {
          case 'cancel':
            btnLeft.txt = case1.case3.input8 || 'cancel';
            break;
          case 'customize':
            btnLeft.txt = case1.case3.input5 || 'confirm';
            btnLeft.href = case1.case3.input6 || '';
            break;
        }
        configuration.configuration.list.push(btnLeft);
      }
      if (case1.boxes1) {
        const btnRight = {};
        btnRight.type = 'confirm';
        switch (case1.case2 && case1.case2.clickType2) {
          case 'cancel':
            btnRight.txt = case1.case2.input7 || 'cancel';
            break;
          case 'customize':
            btnRight.txt = case1.case2.input3 || 'confirm';
            btnRight.href = case1.case2.input4 || '';
            btnRight.onCallback = function () {
              // 解决方案只有合作伙伴页才需要这个逻辑
              if (window.location.href.indexOf('partner') === -1 || btnRight.href.indexOf('partners') === -1) {
                window.location.href = formatUrlString(btnRight.href);
                return;
              }
              window.checkAccountType();
            };
            break;
        }
        configuration.configuration.list.push(btnRight);
      }
    }
  }
  return {
    modTitle,
    configuration,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatButton = formatButton(data, {
        domains
      }),
      modTitle = _formatButton.modTitle,
      configuration = _formatButton.configuration,
      bgColor = _formatButton.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    let btnShow = null;
    // console.log('configuration', configuration);
    switch (configuration.clickType1) {
      case 'openUrl':
        btnShow = /*#__PURE__*/React.createElement(TciButton, {
          flexTitle: modTitle,
          txt: configuration.txt,
          colType: configuration.colType,
          sizeType: configuration.sizeType,
          alignType: configuration.alignType,
          colorTheme: configuration.colorTheme,
          onCallback: configuration.callback,
          extendProps: configuration.extendProps
        });
        break;
      case 'btn':
        btnShow = /*#__PURE__*/React.createElement(ButtonPopup, {
          flexTitle: modTitle,
          txt: configuration.txt,
          colType: configuration.colType,
          sizeType: configuration.sizeType,
          alignType: configuration.alignType,
          configuration: configuration.configuration,
          colorTheme: configuration.colorTheme,
          extendProps: configuration.extendProps
        });
        break;
      default:
        btnShow = null;
        break;
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle,
      style: bgColor ? bgStyle : {}
    }, (0, _reportUtil.reportShow)(['show_button', componentKey, modTitle])), btnShow);
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}